export const GET_MEDICAL_BILLS = "booking/GET_MEDICAL_BILLS";
export const GET_MEDICAL_BILLS_SUCCESS = "booking/GET_MEDICAL_BILLS_SUCCESS";
export const GET_MEDICAL_BILLS_FAILURE = "booking/GET_MEDICAL_BILLS_FAILURE";

export const CANCEL_MEDICAL_BILL = "booking/CANCEL_MEDICAL_BILL";
export const CANCEL_MEDICAL_BILL_SUCCESS =
  "booking/CANCEL_MEDICAL_BILL_SUCCESS";
export const CANCEL_MEDICAL_BILL_FAILURE =
  "booking/CANCEL_MEDICAL_BILL_FAILURE";
export const CLEAR_CANCELED_BOOKING_MESSAGE =
  "booking/CLEAR_CANCELED_BOOKING_MESSAGE";

export const GET_MEDICAL_BILL_DETAIL = "booking/GET_MEDICAL_BILL_DETAIL";
export const GET_MEDICAL_BILL_DETAIL_SUCCESS =
  "booking/GET_MEDICAL_BILL_DETAIL_SUCCESS";
export const GET_MEDICAL_BILL_DETAIL_FAILURE =
  "booking/GET_MEDICAL_BILL_DETAIL_FAILURE";
export const SET_MEDPRO_CARE_ROOM = "booking-gateway/telemed/meeting/rooms";
export const RESEND_SMS = "booking/RESEND_SMS";
export const RESEND_SMS_SUCCESS = "booking/RESEND_SMS_SUCCESS";
export const RESEND_SMS_FAILURE = "booking/RESEND_SMS_FAILURE";

export const SUBMIT_BOOKING = "booking/SUBMIT_BOOKING";
export const LOADING_SUBMIT_BOOKING = "booking/LOADING_SUBMIT_BOOKING";
export const SUBMIT_BOOKING_SUCCESS = "booking/SUBMIT_BOOKING_SUCCESS";
export const SUBMIT_BOOKING_FAIL = "booking/SUBMIT_BOOKING_FAIL";
export const RESET_ERROR_SUBMIT_BOOKING = "booking/RESET_ERROR_SUBMIT_BOOKING";
export const RESET_IS_REDIRECT_TO_PAYMENT_SUPPORT_AND_PAYMENT_OFFLINE_PAGE =
  "booking/RESET_IS_REDIRECT_TO_PAYMENT_SUPPORT_AND_PAYMENT_OFFLINE_PAGE";

export const CHECK_DUPLICATE_BOOKING = "booking/CHECK_DUPLICATE_BOOKING";
export const RESET_DUPLICATE_BOOKING = "booking/RESET_DUPLICATE_BOOKING";

export const HIDDEN_BILL = "booking/HIDDEN_BILL";
export const HIDDEN_BILL_SUCCESS = "booking/HIDDEN_BILL_SUCCESS";
export const HIDDEN_BILL_FAIL = "booking/HIDDEN_BILL_FAIL";

export const UPDATE_BOOKING = "UPDATE_BOOKING";
export const UPDATE_BOOKING_LOADING = "UPDATE_BOOKING_LOADING";
export const UPDATE_BOOKING_SUCCESS = "UPDATE_BOOKING_SUCCESS";
export const UPDATE_BOOKING_FAIL = "UPDATE_BOOKING_FAIL";
export const GET_MEDPRO_CARE = "GET_MEDPRO_CARE";
export const SET_MEDPRO_CARE = "SET_MEDPRO_CARE";
export const SELECT_MEDPRO_CARE = "SELECT_MEDPRO_CARE";
